import React, { useEffect, useState, useRef } from 'react';
import { Globe } from 'lucide-react';
import { useLanguage, languages } from '../../hooks/useLanguage';
import { motion, AnimatePresence } from 'framer-motion';
export function LanguageToggle() {
  const {
    language,
    setLanguage
  } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);
  const currentLang = languages.find(l => l.code === language);
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  return <div className="relative z-50" ref={menuRef} data-id="element-235">
      <button onClick={() => setIsOpen(!isOpen)} className="flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/10 hover:bg-white/20 transition-colors text-white border border-white/20" aria-label="Change language" aria-expanded={isOpen} data-id="element-236">
        <Globe className="w-4 h-4" data-id="element-237" />
        <span className="text-sm font-medium" data-id="element-238">
          {currentLang?.code.toUpperCase()}
        </span>
      </button>

      <AnimatePresence data-id="element-239">
        {isOpen && <motion.div initial={{
        opacity: 0,
        y: 8,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 8,
        scale: 0.95
      }} transition={{
        duration: 0.15
      }} className="absolute right-0 mt-2 w-40 bg-white rounded-xl shadow-xl border border-gray-100 overflow-hidden py-1" data-id="element-240">
            {languages.map(lang => <button key={lang.code} onClick={() => {
          setLanguage(lang.code);
          setIsOpen(false);
        }} className={`w-full text-left px-4 py-2.5 text-sm flex items-center justify-between hover:bg-gray-50 transition-colors ${language === lang.code ? 'font-semibold text-[#D97757] bg-orange-50' : 'text-gray-700'}`} data-id="element-241">
                <span data-id="element-242">{lang.label}</span>
                <span className="text-base" data-id="element-243">{lang.flag}</span>
              </button>)}
          </motion.div>}
      </AnimatePresence>
    </div>;
}